module.exports = __webpack_public_path__ + "img/C08TechGadaWarriorChampion_ua.37ae9c37.webp";